import { Box, Typography } from "@mui/material";
export default function EmptyState({
  title = "No records yet",
  description = "Records will appear here when available.",
  action,
}) {
  return (
    <Box role="status" sx={{ px: 2, py: 5, textAlign: "center" }}>
      <Typography variant="subtitle1" fontWeight={650}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 0.5, mb: action ? 2 : 0 }}
      >
        {description}
      </Typography>
      {action}
    </Box>
  );
}
